/* template */
<template><page><base-container :class='["slider-view"]'><div :class='["content"]'><div :class='["section"]'><div>基本用法</div><slider-default></slider-default></div><div :class='["section"]'><div>设置step</div><slider-step></slider-step></div><div :class='["section"]'><div>显示当前value</div><slider-value></slider-value></div><div :class='["section"]'><div>设置最小值/最大值</div><slider-min-max></slider-min-max></div><div :class='["section"]'><div>自定义滑块儿</div><slider-slot></slider-slot></div></div></base-container></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_49e58972"}'>
.slider-view
  height: 100vh
  .section
    margin: 0 -10px
    margin-bottom: 10px
    background-color: #f7f8fa
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_49e58972"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_49e58972"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_49e58972"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'slider-default':getComponent(require("./slider-default.mpx?isComponent&outputPath=components%2Fslider-default1491d0a4%2Findex")),'slider-slot':getComponent(require("./slider-slot.mpx?isComponent&outputPath=components%2Fslider-slot02a73942%2Findex")),'slider-step':getComponent(require("./slider-step.mpx?isComponent&outputPath=components%2Fslider-stepd6d52da6%2Findex")),'slider-value':getComponent(require("./slider-value.mpx?isComponent&outputPath=components%2Fslider-valuefa262744%2Findex")),'slider-min-max':getComponent(require("./slider-min-max.mpx?isComponent&outputPath=components%2Fslider-min-max5ce29654%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>